import { render, staticRenderFns } from "./counter.vue.js?vue&type=template&id=4735ca82!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./counter.vue?vue&type=template&id=4735ca82"
import script from "./counter.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./counter.vue?vue&type=script&lang=js"
export * from "./counter.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports